import React, {useMemo, useEffect, useState, useCallback} from 'react';
import Table from "v4/components/ui/Table/Table";
import {Link} from "react-router-dom";
import {routesBase} from 'v4/data/appRoutes'
import useFetch from "v4/hooks/useFetch";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import apiService from "v4/services/api.service";
import {
    PRODUCT_CONFIGURATION_LIST,
} from "v4/data/apiRoutes";
import {PolIcon} from "components/PolIcon/policon";
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import useNotification from "v4/hooks/useNotification";
import ProductConfigurationsListDelete
    from "v4/pages/admin/ProductConfigurations/ProductConfigurationsDelete/ProductConfigurationsListDelete";
export default function ProductConfigurationsList({customerId}) {
    const {t} = usePolTranslation()
    const {addSuccessNotification, addErrorNotification} = useNotification()
    // Listing
    const [{
        data: loadedProductConfigurations,
        isLoading: loadedProductConfigurationsLoading,
        isError: loadedProductConfigurationsError
    }, fetchProductConfigurations] = useFetch();
    const [refetch, setRefetch] = useState(0)
    useEffect(() => {
        fetchProductConfigurations({
            url: apiService.generateUrl(PRODUCT_CONFIGURATION_LIST, {
                sortField: "label",
                sortOrder: "asc",
                customerId: customerId
            }),
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch])
    const onDeleteSuccess = useCallback(() => {
        addSuccessNotification(t('delete_product_configuration_done'))
        setRefetch(c => c + 1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch])
    const onDeleteError = useCallback(() => {
        addErrorNotification(t('delete_product_configuration_error'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const hydrateProductConfigurationRows = useCallback(() => {
        if (!loadedProductConfigurations?.['hydra:member']) {
            return null
        }
        const rows = JSON.parse(JSON.stringify(loadedProductConfigurations['hydra:member']))
        return (
            rows.map((item, index) => {
                return {
                    label: item.label,
                    product_attributes: item.productAttributes.map((attribute) => {
                        return attribute.label
                    }).join(' ; '),
                    actions: (
                        <ul className="datatable__actions">
                            <Link key={index} to={`${routesBase.adminProductConfigurations}/${item.id}/edit`}>
                                <li className="datatable__actions__item">
                                    <span className="datatable__actions__item__icon">
                                        <PolIcon icon='edit'/>
                                    </span>
                                </li>
                            </Link>
                            <ProductConfigurationsListDelete item={item} onSuccessCallback={onDeleteSuccess}
                                                     onErrorCallBack={onDeleteError}/>
                        </ul>
                    )
                };
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedProductConfigurations])
    const tableList = useMemo(() => {
        return <Table tableRows={hydrateProductConfigurationRows()} isLoading={loadedProductConfigurationsLoading}
                      isError={loadedProductConfigurationsError}
                      theadData={Object.keys({label: 'label', product_attributes: 'product_attributes', actions: 'actions'})}/>
    }, [hydrateProductConfigurationRows, loadedProductConfigurationsLoading, loadedProductConfigurationsError])
    const CardHeaderTools = () => (
        <Link to={`${routesBase.adminProductConfigurations}/add`}
              className="btn btn-primary">{t('add_new_product_configuration')}</Link>
    )
    return (
        <AdminCard title={t('manage_product_configurations')} CardHeaderTools={CardHeaderTools}>
            {tableList}
        </AdminCard>
    )
}